module.exports = __webpack_public_path__ + "static/media/vip_discover.228a0c43.svg";